/**
 * AWS konfigurationsfil for frontend applikationen
 * Denne fil indeholder alle nødvendige konfigurationer for at forbinde frontend med AWS tjenester
 */

const awsconfig = {
  // Autentificeringskonfiguration - bruges til bruger login og registrering
  Auth: {
    region: 'eu-west-1', // AWS region (Irland)
    userPoolId: 'YOUR_USER_POOL_ID', // ID for Cognito brugerpool
    userPoolWebClientId: 'YOUR_CLIENT_ID', // ID for web-klienten i Cognito
  },

  // API konfiguration - bruges til at kommunikere med backend
  API: {
    GraphQL: {
      endpoint: 'https://ok31souttj.execute-api.eu-west-1.amazonaws.com/prod/graphql', // URL til API Gateway endpoint
      region: 'eu-west-1',
      authenticationType: 'AMAZON_COGNITO_USER_POOLS', // Bruger Cognito til autentificering
    },
  },

  // S3 konfiguration - bruges til at hoste frontend filer
  Storage: {
    AWSS3: {
      bucket: 'svirrens-frontend', // Navn på S3 bucket hvor frontend hostes
      region: 'eu-west-1',
    },
  },

  // CloudFront konfiguration - bruges til CDN og HTTPS
  CloudFront: {
    distributionId: 'E65SDDSDDIOZY', // ID for CloudFront distribution
    domain: 'svirrens.com', // Custom domain
    cloudfrontDomain: 'dyfk2xxs4y2d7.cloudfront.net', // CloudFront domæne (f.eks. d1234.cloudfront.net)
  },
};

export default awsconfig;